import React, { useState, useEffect, useCallback } from "react";
import { HeadingFour, MyDiv } from "../Common/Components";
import { Row, Col, Card, Spinner, Button } from "react-bootstrap";
import { CommonFormFields } from "../Common/commonFormFields";
import { projectStatus, projectType, projectContractStatus, projectBillingType } from "../Common/Constants/staticjson";
import swal from "sweetalert2";
import PropTypes from "prop-types";
import { getRequest, patchRequest,postRequest } from "../Common/api/apiService";

function FormProjects({ handleClose, projectEditId }) {
  const [employees, setEmployees] = useState([]);
  const [btnLoading, setbtnLoading] = useState(false);
  const [customerData, setCustomerData] = useState([]);
  const [data, setData] = useState({
    pro_name: "",
    // pro_code: "",
    pro_description: "",
    pro_owner: "",
    pro_approver: "",
    pro_startDate: "",
    pro_endDate: "",
    pro_costCenter: "",
    pro_contractStatus: "",
    pro_customer_id: "",
    pro_status: "",
    pro_type: "",
    pro_totalHours: "",
    pro_contractRenewDate: "",
    pro_billingType: "",
  });



  const loadSpecificProject = useCallback(async () => {
    const query = `fetchspecificProject/${projectEditId}`;
    try {
      const response = await getRequest(query);
      if (response?.data) {
        setData(
          response.data[0]
        );
      }
    } catch (error) {
      console.log(error);
    }
  }, [projectEditId]);

  const loadAllEmployee = useCallback(async () => {
    const query = `fetchallemployee`;
    try {
      const response = await getRequest(query);
      if (response?.data) {
        setEmployees(response.data || []);
      }
    } catch (error) {
      console.log(error);
    }
  }, []);


  const loadCustomer = useCallback(async () => {
    const query = `fetchcustomer`;
    try {
      const response = await postRequest(query);
      if (response?.data) {
        setCustomerData(
          response.data
        );
      }
    } catch (error) {
      console.log(error);
    }
  }, []);


  useEffect(() => {
  if (projectEditId !== undefined) {
    loadSpecificProject();
  }
  loadAllEmployee();
  loadCustomer();
}, [projectEditId, loadSpecificProject, loadAllEmployee, loadCustomer]);



  function handle(e) {
    const newdata = { ...data };
    newdata[e.id] = e.value;
    setData(newdata);
  }

  async function submit(e) {
    e.preventDefault();
    setbtnLoading(true);

    const url = projectEditId ? `updateproject/${projectEditId}` : `addproject`;
    const method = projectEditId ? patchRequest : postRequest;

    try {
      const response = await method(url, data);
      if (response.status === 200) {
        swal.fire({
          text: "Successfully Saved",
          icon: "success",
          type: "success",
        });
        handleClose();
      }
    } catch (error) {
      swal.fire({
        text: error.response?.data || "An error occurred",
        icon: "error",
        type: "error",
      });
    } finally {
      setbtnLoading(false);
    }
  }

  return (
    <MyDiv className="DrawerRight">
      <MyDiv className="grid-margin general-form stretch-card">
        <Card md={12}>
          <Card.Header>
            <HeadingFour className="card-title">{projectEditId ? "Edit" : "Add"} Projects</HeadingFour>
          </Card.Header>
          <Card.Body>
            <MyDiv className="DrawerForm">
              <form onSubmit={submit}>
                <Row className="DrawerFormField">
                  <Col md={12}>
                    <CommonFormFields type="text" id="pro_name" label="Projects Name" value={data.pro_name} onChange={handle} required validationType="alphabet" />
                  </Col>               
                  <Col md={12}> 
                    <CommonFormFields type="text" id="pro_description" label="Project Description" multiline rows={2} maxRows={4} value={data.pro_description} onChange={handle} required validationType="alphanumeric" />
                  </Col>
                  <Col md={12}>        
                    <CommonFormFields type="date" id="pro_startDate" label="Project Start Date" value={data.pro_startDate} max={new Date().toISOString().split("T")[0]} sx={{ width: 220 }} onChange={handle} InputLabelProps={{ shrink: true }} required />
                  </Col>
                  <Col md={12}>    
                    <CommonFormFields
                      type="date"
                      id="pro_endDate"
                      max={new Date().toISOString().split("T")[0]}
                      label="Project End Date"
                      value={data.pro_endDate}
                      sx={{ width: 220 }}
                      onChange={handle}
                      required
                      InputLabelProps={{ shrink: true }}
                    />
                  </Col>
                  <Col md={12}>              
                    <CommonFormFields
                      type="select"
                      id="pro_owner"
                      name="pro_owner"  
                      label="Projects Owner"
                      value={data.pro_owner || ""}
                       onChange={handle}
                      required
                      options={(employees || []).map(proEmployee => ({
                        value: proEmployee.id,
                        label: proEmployee.name,
                      }))}
                    />                 
                  </Col>
                  <Col md={12}>                  
                    <CommonFormFields
                      type="select"
                      id="pro_approver"
                       name="pro_approver"
                      label="Projects Approver"
                      value={data.pro_approver || []}
                      multiple={true}
                       onChange={handle}
                      required
                      options={employees.map(proEmployee => ({
                        value: proEmployee.id,
                        label: proEmployee.name,
                      }))}
                    />
                  </Col>
                  <Col md={12}>       
                    <CommonFormFields
                      type="select"
                      id="pro_customer_id"
                       name="pro_customer_id"
                      label="Projects Customer"
                      value={data.pro_customer_id || ""}
                      multiple={false}
                       onChange={handle}
                      required
                      options={(Array.isArray(customerData) ? customerData : []).map(customer => ({
                        value: customer._id,
                        label: customer.cus_name,
                        company: customer.cus_company
                      }))}
                    />
                  </Col>
                  <Col md={12}>                
                    <CommonFormFields type="text" id="pro_totalHours" label="Project Total Hours" value={data.pro_totalHours} onChange={handle} required validationType="numeric" />
                  </Col>
                  <Col md={12}>             
                    <CommonFormFields type="text" id="pro_costCenter" label="Cost Center" value={data.pro_costCenter} onChange={handle} required validationType="alphanumeric" />
                  </Col>
                  <Col md={12}>   
                    <CommonFormFields type="date" id="pro_contractRenewDate" label="Contract Renew Date" max={new Date().toISOString().split("T")[0]} value={data.pro_contractRenewDate} sx={{ width: 220 }} onChange={handle} required InputLabelProps={{ shrink: true }} />
                  </Col>
                  <Col md={12}>                 
                    <CommonFormFields
                      type="select"
                      id="pro_billingType"
                      label="Billing Type"
                       name="pro_billingType"
                      value={data.pro_billingType || []}
                       onChange={handle}
                      required
                      options={projectBillingType.map(proBillingType => ({
                        value: proBillingType.value,
                        label: proBillingType.label,
                      }))}
                    />
                  </Col>
                  <Col md={12}>                 
                    <CommonFormFields
                      type="select"
                      id="pro_contractStatus"
                       name="pro_contractStatus"
                      label="Projects Contract Status"
                      value={data.pro_contractStatus || []}
                       onChange={handle}
                      required
                      options={projectContractStatus.map(proContStatus => ({
                        value: proContStatus.value,
                        label: proContStatus.label,
                      }))}
                    />

                  </Col>
                  <Col md={12}>                  
                    <CommonFormFields
                      type="select"
                      id="pro_status"
                       name="pro_status"
                      label="Projects Status"
                      value={data.pro_status}
                      onChange={handle}
                      required
                      options={projectStatus.map(cusStatus => ({
                        value: cusStatus.value,
                        label: cusStatus.label,
                      }))}
                    />
                  </Col>
                  <Col md={12}>            
                    <CommonFormFields
                      type="select"
                      id="pro_type"
                       name="pro_type"
                      label="Projects Type"
                      value={data.pro_type}
                     onChange={handle}
                      required
                      options={projectType.map(proType => ({
                        value: proType.value,
                        label: proType.label,
                      }))}
                    />
                  </Col>
                  <Col md={12} className="text-end">               
                    {btnLoading ? (
                      <Button variant="primary" disabled className="FormBtn">
                        <Spinner as="span" animation="border" size="sm" aria-hidden="true" className="mx-2" />
                        Creating...
                      </Button>
                    ) : (
                      <button type="submit" className="FormBtn">
                        Submit
                      </button>
                    )}
                  </Col>
                </Row>
              </form>
            </MyDiv>
          </Card.Body>
        </Card>
      </MyDiv>
    </MyDiv>
  );
}
export default FormProjects;
FormProjects.propTypes = {
  handleClose: PropTypes.any,
  projectEditId: PropTypes.any,
};
